import Script from 'next/script';

const BookingCompletionScript = () => {
  return process.env.NEXT_PUBLIC_ENGAGE_BOT_EMAIL_APP_ID &&
    process.env.NEXT_PUBLIC_ENGAGE_BOT_TELEPHONE_APP_ID &&
    process.env.NEXT_PUBLIC_ENGAGE_BOT_SDK_WEB_FORM_SUBMITTED_SCRIPT ? (
    <>
      <Script id="booking-completion" strategy="afterInteractive" type="text/javascript">
        {`
          window.ebSettings_2 = [{
            eb_appId: '${process.env.NEXT_PUBLIC_ENGAGE_BOT_EMAIL_APP_ID}', 
          }, {
            eb_appId: '${process.env.NEXT_PUBLIC_ENGAGE_BOT_TELEPHONE_APP_ID}',
          }];
        `}
      </Script>
      <Script
        id="booking-completion-script"
        strategy="afterInteractive"
        src={process.env.NEXT_PUBLIC_ENGAGE_BOT_SDK_WEB_FORM_SUBMITTED_SCRIPT}
      />
    </>
  ) : null;
};

export default BookingCompletionScript;
